<template>
  <v-dialog
    max-width="800"
    v-model="completeCampaignDialogOpened"
  >
    <v-card>
      <v-card-title class="text-h5 error text-white">
        Complete store
      </v-card-title>

      <v-card-text>
        <div class="text-h6" style="line-height:1.4 !important">
          <p class="mt-2 mb-3">
            Do you want to complete store
            <strong>"{{ $props.campaign.name }}"?</strong>
          </p>
        </div>

        <v-form ref="completeDialogForm" v-on:submit.prevent="onSubmit">
          <v-row>
            <v-col cols="12">
              <v-text-field
                color="error"
                v-model="distributorPO"
                :rules="[validateNotEmpty]"
                label="Distributor PO *"
                required
                data-testid="cl-complete-input"
              />
            </v-col>
          </v-row>
        </v-form>

        <v-alert color="error" icon="priority_high" variant="outlined">
          Once a store is marked <strong>"completed"</strong> you will not be
          able to make changes to shopper orders.
        </v-alert>
      </v-card-text>

      <v-divider />

      <v-card-actions class="py-3 px-3">
        <v-spacer />

        <v-btn
          variant="outlined"
          color="error"
          @click="$emit('close-modal')"
          data-testid="cl-complete-cancel"
        >
          Cancel
        </v-btn>

        <v-btn
          ref="completeButton"
          :disabled="!distributorPO.replace(/\s/g, '')"
          color="error"
          @click="$emit('complete-campaign', $props.campaign, distributorPO)"
          data-testid="cl-complete-confirm"
        >
          Complete
          <template v-slot:loader>
            <span>Saving...</span>
          </template>
        </v-btn>
      </v-card-actions>
      <slot name="progress"></slot>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/rules";

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },

    modalPopped: {
      type: Boolean,
      required: true,
    },
  },

  mixins: [rules],

  watch: {
    completeCampaignDialogOpened(val) {
      !val && this.$emit("close-modal");
    },
  },

  data() {
    return {
      distributorPO: "",
      completeCampaignDialogOpened: true,
    };
  },

  methods: {
    //sends out complete-campaign event on form submit
    //allows for pressing enter in distributor number dialog
    onSubmit() {
      this.$emit(
        "complete-campaign",
        this.$props.campaign,
        this.$data.distributorPO
      );
    },
  },
};
</script>

